<div class="container mt-4">
  <div class="row">
    <div class="col-lg-12">
      <div class="text-center mb-5">
        <h1 class="display-2 fw-medium">
          <i class="bx bx-lock-alt text-warning display-3"></i>
        </h1>
        <h4 class="text-uppercase text-warning">Sem Permissão</h4>
        <p class="text-muted mt-3 font-size-18">
          Você não tem permissão para acessar esta página.
          <br />Entre em contato com o administrador do sistema para mais
          informações.
        </p>
        <div class="mt-5 text-center">
          <a class="btn btn-warning" routerLink="/">Voltar para o Dashboard</a>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div
      class="col-md-8 col-xl-6"
      style="
        text-align: center;
        justify-content: center;
        display: flex;
        align-items: center;
      "
    >
      <div>
        <img
          src="assets/images/no-permission.svg"
          alt="Sem Permissão"
          class="img-fluid"
          style="height: 280px"
        />
      </div>
    </div>
  </div>
</div>
